module.exports = __webpack_public_path__ + "static/media/1010708.eb184473.png";